import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class MerchantProfilesService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/merchant_profiles", { params: toSnakeCase(params) });
  }

  fetch(id, params) {
    return securedAxiosInstance.get(`/merchant_profiles/${id}`, { params: toSnakeCase(params) });
  }

  delete(id) {
    return securedAxiosInstance.delete(`/merchant_profiles/${id}`);
  }

  update(id, params) {
    return securedAxiosInstance.put(`/merchant_profiles/${id}`, {
      merchant_profile: toSnakeCase(params),
    });
  }

  create(merchantProfileData, storeId, organizationId) {
    return securedAxiosInstance.post("/merchant_profiles", {
      merchant_profile: toSnakeCase(merchantProfileData),
      store_id: storeId,
      organization_id: organizationId,
    });
  }

  sendBulkInvitation(merchantProfileIds) {
    return securedAxiosInstance.post("/merchant_profiles/send_bulk_invitation", {
      merchant_profile_ids: merchantProfileIds,
    });
  }
}

export default new MerchantProfilesService();
